module.exports = __webpack_public_path__ + "static/media/44471994_2199890603419452_5709271112852963328_o-thumb.d6245a54.jpg";